import React, { useEffect, useRef, useState } from 'react';

import useSignupRedirectUrl, { DEFAULT_SIGNUP_CONFIG, getSignupConfig } from 'hooks/useSignupRedirectUrl/useSignupRedirectUrl';
import AuthPage from 'pages/AuthPage';
import { AUTH_PATHS } from 'router/PATHS';

const AuthSignupRedirectPage = () => {
  const { redirectToSignup } = useSignupRedirectUrl();
  const [isLoading, setIsLoading] = useState(true);
  const [signupConfig, setSignupConfig] = useState(DEFAULT_SIGNUP_CONFIG);
  const hasRedirectedRef = useRef(false);

  useEffect(() => {
    let isMounted = true;

    getSignupConfig().then(config => {
      if (!isMounted) return;

      setSignupConfig(config);
      setIsLoading(false);

      if (!config.selfServiceSignupEnabled && !hasRedirectedRef.current) {
        hasRedirectedRef.current = true;
        redirectToSignup();
      }
    });

    return () => {
      isMounted = false;
    };
  }, [redirectToSignup]);

  useEffect(() => {
    if (!isLoading && !signupConfig.selfServiceSignupEnabled && !hasRedirectedRef.current) {
      hasRedirectedRef.current = true;
      redirectToSignup();
    }
  }, [isLoading, redirectToSignup, signupConfig.selfServiceSignupEnabled]);

  if (isLoading || !signupConfig.selfServiceSignupEnabled) return null;

  return <AuthPage signupEnabled typeOverride={AUTH_PATHS.REGISTER} />;
};

export default AuthSignupRedirectPage;
